import React from 'react';

const SectionIsPublicity = ({
  isPublicity,
  setIsPublicity
}) => {
  return (
    <section id="is_publicity">
      <div className="container col-md-8 col-lg-6">
        <div style={{ display: 'flex' }}>
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2_5 mt-4 d-inline-block">
            プロジェクトの表示設定
          </p>
        </div>
      </div>
      <div className="shadow-sm mb-3 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="custom-control custom-switch custom-switch-md">
            <input
              type="checkbox"
              className="custom-control-input"
              id="isPublicity"
              defaultChecked={isPublicity}
              onChange={e => {
                setIsPublicity(e.target.checked);
              }}
            />
            <label
              className="custom-control-label"
              htmlFor="isPublicity"
            >
              クラファンを表示する
            </label>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionIsPublicity;
